import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { CoursesService } from '../../../providers/courses.service';

@Component({
  selector: 'app-course-card-iit',
  templateUrl: './course-card-iit.component.html',
  styleUrls: ['./course-card-iit.component.scss']
})

export class CourseCardIitComponent {

  
  @Input('course') course: any;

  @Input('pageName') pageName: any;
  
  constructor(public coursesService: CoursesService, public router: Router, @Inject(LOCAL_STORAGE) public sessionStorage: any,) {

  }

  ngOnInit(): void {

  }

  goToCoureLink(course:any){
    if(course.link){
      window.open(course.link)
    }
    
  }

  
  details(course: any) {
    // let name:any = 'CAT 2023 Full Course + IIM ABC Practice Batch'
    // this.router.navigate(['/details/'+ name.toLowerCase().replaceAll(' ', '-')])
    window.open(course.course_link, '_self')
  }

  courseDetails: any;

  buynow(evt: any) {
    if (this.course.display_only_one) {
      // let name:any = 'CAT 2023 Full Course + IIM ABC Practice Batch'
      // this.router.navigate(['/details/'+ name.toLowerCase().replaceAll(' ', '-')])
      window.open(this.course.course_link, '_self')
    } else {
      let courseId = evt.id;
      this.coursesService.courseDetails(courseId).subscribe(res => {
        if (res.length > 0) {
          this.courseDetails = res[0];
          this.sessionStorage.setItem('cartArray', JSON.stringify(this.courseDetails))
          this.router.navigate(['cart'])
        }
      })
    }
  }

}